var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427318649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6902 8.53013C24.0807 8.1396 24.0807 7.50644 23.6902 7.11591L20.5605 3.98625C20.17 3.59573 19.5368 3.59573 19.1463 3.98625L4.07056 19.062C3.68003 19.4525 3.68003 20.0857 4.07056 20.4762L7.20022 23.6059C7.59074 23.9964 8.22391 23.9964 8.61443 23.6059L23.6902 8.53013Z",
    fill: "#279EFF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2861 8.52471C22.6766 8.91523 23.3097 8.91523 23.7003 8.52471L25.2618 6.96313C26.5112 5.71374 26.5112 3.67515 25.2618 2.42576C24.0125 1.17637 21.9739 1.17637 20.7245 2.42576L19.1629 3.98734C18.7724 4.37786 18.7724 5.01103 19.1629 5.40155L22.2861 8.52471Z",
    fill: "#279EFF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.64772 24.7287C1.49269 25.1024 1.57818 25.5328 1.8643 25.8189C2.15043 26.105 2.58079 26.1905 2.95456 26.0355L8.30074 23.8179C8.60915 23.69 8.83337 23.4165 8.89842 23.089C8.96348 22.7615 8.8608 22.4232 8.6247 22.1871L5.49612 19.0585C5.26003 18.8224 4.92167 18.7197 4.59417 18.7848C4.26668 18.8498 3.99326 19.0741 3.86533 19.3825L1.64772 24.7287Z",
    fill: "#279EFF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil2);
export default __webpack_public_path__ + "static/media/icon_pencil2.7386afa133689c49b2b625cce506ec47.svg";
export { ForwardRef as ReactComponent };